import axios from 'axios'
import { getEndpoint } from 'common/backend/endpoints';

export const getProductHistoryList = async (carID, fields, params = '') => {
    try {
        const endpoint = getEndpoint('PRODUCTO')
        const res = await axios.get(endpoint + '/' + carID + `/prices?fields=${fields}${params}`)
        return res.data
    } catch (error) {
        throw new error
    }
  }
